<template>
  <span class="promotion-active-badge">Promotion Active</span>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.promotion-active-badge {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 2px 12px;
  border: 1px solid #f1c983;
  border-radius: 999px;
  background: #fff3da;
  color: #9a5a00;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.2;
  white-space: nowrap;
}
</style>
